
const digest = 'a404946a1bdb52aba9b6a7e08897bc24a9eb573f2460950631d9b290d77d4e4b';
const classes = {"wrapper":"_wrapper_1qhqy_1","price":"_price_1qhqy_5","active":"_active_1qhqy_10"};
const css = `._wrapper_1qhqy_1 {
  display: flex;
  gap: 10px;
}
._wrapper_1qhqy_1 ._price_1qhqy_5 {
  color: #aaaaaa;
  border-left: 1px solid #cececf;
  padding-left: 10px;
}
._wrapper_1qhqy_1._active_1qhqy_10 ._price_1qhqy_5 {
  color: #ffffff;
  border-color: #4648a1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  